/* =====================================================
   Luxury Collections Grid — interactions
   - IntersectionObserver fade-up reveal
   - Pointer-tracking glow (rAF throttled, GPU friendly)
   - Respects prefers-reduced-motion
   ===================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initSection(section) {
    if (section.dataset.lcgInit === '1') return;
    section.dataset.lcgInit = '1';

    var cards = section.querySelectorAll('[data-lcg-card]');
    if (!cards.length) return;

    /* ---------- Reveal on scroll ---------- */
    if (reduceMotion || !('IntersectionObserver' in window)) {
      cards.forEach(function (c) { c.classList.add('is-visible'); });
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      cards.forEach(function (c) { io.observe(c); });
    }

    /* ---------- Pointer glow (desktop, fine pointer only) ---------- */
    var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (!fine || reduceMotion) return;

    cards.forEach(function (card) {
      var media = card.querySelector('.lcg-card__media');
      var glow = card.querySelector('.lcg-card__glow');
      if (!media || !glow) return;

      var rafId = 0;
      var pendingX = 50, pendingY = 50;

      function apply() {
        rafId = 0;
        glow.style.setProperty('--mx', pendingX + '%');
        glow.style.setProperty('--my', pendingY + '%');
      }

      card.addEventListener('pointermove', function (e) {
        var rect = media.getBoundingClientRect();
        pendingX = ((e.clientX - rect.left) / rect.width) * 100;
        pendingY = ((e.clientY - rect.top) / rect.height) * 100;
        if (!rafId) rafId = requestAnimationFrame(apply);
      }, { passive: true });

      card.addEventListener('pointerleave', function () {
        pendingX = 50; pendingY = 50;
        if (!rafId) rafId = requestAnimationFrame(apply);
      }, { passive: true });
    });
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-lcg]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  /* Shopify theme editor reload support */
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
